var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ShadowedBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  background-color: #ffffff;\n  box-shadow: 0 5px 12px 0 rgba(29, 114, 104, 0.14);\n"], ["\n  box-sizing: border-box;\n  background-color: #ffffff;\n  box-shadow: 0 5px 12px 0 rgba(29, 114, 104, 0.14);\n"])));
var templateObject_1;
//# sourceMappingURL=ShadowedBox.js.map